export const columns = [
  // {
  //   title: "系统名称",
  //   width: 150,
  //   key: "systemName",
  //   slots: { customRender: "systemName" },
  // }
  // ,
  {
    title: "材料编号",
    width: 200,
    key: "bizNo",
    slots: { customRender: "id" },
  },
  {
    title: "材料名称",
    width: 200,
    dataIndex: "name",
    key: "name",
  },
  {
    title: "规格型号",
    width: 150,
    dataIndex: "model",
    key: "model",
  },
  {
    title: "品牌",
    width: 100,
    dataIndex: "materialCategoryBrandName",
    key: "materialCategoryBrandName",
  },
  {
    title: "所属分类",
    width: 200,
    dataIndex: "materialCategoryName",
    key: "materialCategoryName",
  },
  {
    title: "结算单位",
    width: 100,
    dataIndex: "unitName",
    key: "unitName",
  },
  {
    title: "预算成本价",
    width: 100,
    dataIndex: "costPrice",
    key: "costPrice",
  },
  {
    title: "市场销售价",
    width: 100,
    dataIndex: "salesPrice",
    key: "salesPrice",
  },
];
